module.exports = __webpack_public_path__ + "static/IPhone_App_Wizard_01-703bd0e66d26cfcc42606bfd02754bd8.png";